import SearchPageLayout from './SearchPageLayout'

export default SearchPageLayout
